/*
 * The waiter's session, assembled by authService.login from TenantHub's
 * authenticate response plus crs-api's RolePermissions/by-roles lookup.
 * Persisted to sessionStorage (F5-safe) by tokenStore.
 */

export interface WaiterUser {
  userId: string;
  username: string;
  fullName: string;
  email: string | null;
  roles: string[];
}

export interface WaiterSession {
  user: WaiterUser;
  tenantId: string;
  tenantName: string;
  /** `visibleModules` from RolePermissions/by-roles — must contain `dineops-orders`. */
  modules: string[];
  /** `moduleActions` from RolePermissions/by-roles, keyed by module code. */
  actions: Record<string, string[]>;
}

/** Module codes the app gates on (api-contract.md → Permissions). */
export const ORDERS_MODULE = 'dineops-orders';
export const KDS_MODULE = 'dineops-kds';
/** Buffet check-off board: view, mark (and undo), close (buffet slice 2). */
export const BUFFET_MODULE = 'dineops-buffet';
